import { render } from "./DataNavigator.vue?vue&type=template&id=6723525d&scoped=true"
import script from "./DataNavigator.vue?vue&type=script&lang=js"
export * from "./DataNavigator.vue?vue&type=script&lang=js"

import "./DataNavigator.vue?vue&type=style&index=0&id=6723525d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6723525d"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QBtnGroup});
